<template>
  <div class="page">
    <el-card v-loading="loading" shadow="never">
      <div slot="header" class="card-header">
        <span>敏感词管理</span>
      </div>
      <p class="tip">所有敏感词保存在一条配置中，多个词请用英文或中文逗号分隔。评论发布时会自动检测，命中后禁止发表。</p>
      <el-form ref="form" :model="form" label-width="80px" class="config-form">
        <el-form-item label="敏感词">
          <el-input
            v-model="form.keyword"
            type="textarea"
            :rows="8"
            placeholder="请输入敏感词，多个词用逗号分隔&#10;例如：广告, 刷单，违禁词，色情"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width: 200px">
            <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submitting" @click="submit">保存配置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCommentKeywords, saveCommentKeyword } from '@/api/admin'
import { COMMON_STATUS, optionsOf } from '@/utils/adminConstants'

export default {
  name: 'CommentsKeywords',
  data() {
    return {
      loading: false,
      submitting: false,
      form: { keyword: '', status: 1 }
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(COMMON_STATUS)
    }
  },
  created() {
    this.loadConfig()
  },
  methods: {
    dedupeKeywords(text) {
      if (!text) return ''
      const seen = new Set()
      const list = []
      text.split(/[,，]/).forEach(part => {
        const word = part.trim()
        if (!word || seen.has(word)) return
        seen.add(word)
        list.push(word)
      })
      return list.join(',')
    },
    normalizeConfig(data) {
      if (!data) {
        return { keyword: '', status: 1 }
      }
      if (Array.isArray(data)) {
        const keyword = this.dedupeKeywords(data.map(item => item.keyword).filter(Boolean).join(','))
        const status = data.some(item => Number(item.status) === 1) ? 1 : 0
        return { keyword, status }
      }
      return {
        keyword: this.dedupeKeywords(data.keyword || ''),
        status: data.status != null ? data.status : 1
      }
    },
    async loadConfig() {
      this.loading = true
      try {
        const data = await getCommentKeywords()
        this.form = this.normalizeConfig(data)
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    async submit() {
      const normalized = this.dedupeKeywords(this.form.keyword.trim())
      const removed = this.form.keyword.trim() !== normalized
      this.submitting = true
      try {
        await saveCommentKeyword({
          keyword: normalized,
          status: this.form.status
        })
        this.$message.success(removed ? '保存成功，已自动去除重复敏感词' : '保存成功')
        this.loadConfig()
      } catch (e) {
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tip {
  margin: 0 0 20px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
}
.config-form {
  max-width: 720px;
}
</style>
